document.addEventListener("DOMContentLoaded", (event) => {
   $('.promotion-list').slick({
    dots: true,
    infinite: false,
    arrows: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

   $('.featured-collection-slider').slick({
    dots: true,
    infinite: false,
    arrows: false,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

   const filter_menu = document.querySelector('.filters-toolbar .filters-icon');
   const filter_close = document.querySelector('.filters-toolbar__item-wrapper .filters-close');

   if(filter_menu) {
      filter_menu.addEventListener('click', (e)=>{
        document.querySelector('body').classList.add('filter-open');
        document.querySelector('.filters-toolbar__item-wrapper').classList.add('open');
      })
    } 

    if(filter_close) {
      filter_close.addEventListener('click', (e)=>{
        document.querySelector('.filters-toolbar__item-wrapper').classList.remove('open');
        document.querySelector('body').classList.remove('filter-open');
      })
    }
  
  
})